import type { BusinessSetUp, SetUpBusiness } from '@cyberscore/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { navigate, href } from '../../lib/router';
import { useSession } from '../../lib/session';

/** Any company on its own (decision 0034): set up the business, then start its checks. */

export function useSetUpBusiness() {
  const { switchTenant, reload } = useSession();
  return useMutation({
    mutationFn: (body: SetUpBusiness) => api<BusinessSetUp>('POST', '/onboarding/business', body),
    onSuccess: async (r) => {
      // Straight to the first question (task 105), before the app could send the new tenant to its home.
      navigate(href.answer(r.assessment_id));
      switchTenant(r.tenant_id);
      await reload();
    },
  });
}

export function useStartCheck() {
  const qc = useQueryClient();
  const { tenant } = useSession();
  return useMutation({
    mutationFn: () => api<{ assessment_id: string }>('POST', '/onboarding/checks'),
    onSuccess: async (r) => {
      await qc.invalidateQueries({ queryKey: ['assessments', tenant?.id] });
      navigate(href.answer(r.assessment_id));
    },
  });
}
